export default [
  {
    name: 'Boeing 737-700',
    parts: 100,
    price: 150_000,
    priceChange: 500,
    quantity: 10,
    inventionPoints: 0,
  },
  {
    name: 'Helicopter',
    parts: 1,
    price: 15_000,
    priceChange: 250,
    quantity: 5,
    inventionPoints: 0,
  },
  {
    name: 'Airbus A320',
    parts: 99,
    price: 105000,
    priceChange: 400,
    quantity: 1,
    inventionPoints: 0,
  },
  {
    name: 'Baloon',
    parts: 100,
    price: 150_000,
    priceChange: 1_000,
    quantity: 0,
    inventionPoints: 50,
  },
  {
    name: 'F-16',
    parts: 10,
    price: 35_000,
    priceChange: 1_000,
    quantity: 0,
    inventionPoints: 100,
  },
  {
    name: 'Dreamliner',
    parts: 299,
    price: 500_000,
    priceChange: 5_000,
    passengers: 70,
    quantity: 0,
    inventionPoints: 150,
  },
];
